import AddIcon from '@mui/icons-material/Add';
import Modal from '@/trio-ui/Modal';
import { InterviewTypes } from '@/utils/interviews';
import InterviewType from '../InterviewType';

export type ChooseInterviewTypeModalProps = {
  onClose: () => void;
  isOpen: boolean;
  onSelectInterviewType: (type: InterviewTypes) => void;
};

export default function ChooseInterviewTypeModal({
  onClose,
  isOpen,
  onSelectInterviewType,
}: ChooseInterviewTypeModalProps): JSX.Element {
  const interviewTypes = Object.keys(InterviewTypes);

  const onChoose = (type: InterviewTypes): void => {
    onSelectInterviewType(type);
  };

  const Interviews = (
    <>
      {interviewTypes.map((interview) => {
        const type = InterviewTypes[interview];
        return <InterviewType key={type} type={type} onChoose={() => onChoose(type)} />;
      })}
    </>
  );

  return (
    <Modal
      modalId="interview-type-modal"
      headerIcon={AddIcon}
      isCentered
      size="sm"
      modalTitle="Choose an Interview type"
      bodyRender={Interviews}
      isOpen={isOpen}
      onClose={onClose}
    />
  );
}
